import { markRaw } from 'vue'; // 新增导入

export default {
  namespaced: true,
  state: {
    list: [],
    icons: {}
  },
  mutations: {
    setList: (state, payload) => {
      // 使用 markRaw 标记每个图标组件，防止被响应式化
      const markedList = payload.map(item => ({
        ...item,
        icon: markRaw(item.icon) // 关键行
      }));
      state.list = markedList;
      // 重建 icons 映射（同样使用 markRaw）
      state.icons = {};
      for (let o of markedList) {
        state.icons[o.key] = o.icon; // 这里已经是 markRaw 的组件
      }
    },
  },
	actions: {
		// async init({
		// 	commit,
		// 	state
		// }, {
		// 	payload
		// }) {
			
			
		// }
	},
	init: async function() {
		// console.log("icons初始化")
	}
}